export default __webpack_public_path__ + "static/media/shift4shop.3bb9e15b.png";